<template>
    <div :class="isMobile ? '' : 'container'">
        <div class="d-flex justify-content-center align-items-center">
            <i v-if="loadRemove" style="margin: 0 auto;font-size: 40px;"
               class="fas fa-circle-notch fa-spin"></i>
            <div v-if="removed" class="w-100">

              <div v-if="!isMobile">
                <img v-if="event.logo" class="mx-auto d-block" :src="event.logo" height="100px" alt="test">
                <img v-if="event.header" class="mx-auto d-block mb-3" :src="event.header" height="135px"
                     alt="test">
              </div>
              <div v-else>
                <img v-if="event.logo" class="mx-auto d-block" :src="event.logo" height="100px" alt="test">
                <img v-if="event.mobileheader" class="mx-auto d-block" :src="event.mobileheader" height="135px"
                     alt="test">
              </div>
              <div>
                <div :class="isMobile ? '' : 'shadow-lg p-5 mb-5 bg-white rounded'" style="color: #8d8d8d">
                  <div class="text-center mt-3">
                            <span
                                style="font-size: 21px !important; color: #333333; font-family: Poppins">{{ $t
                            ('canceled_appointement') }}</span>
                  </div>
                  <div class="pt-3 pb-4 text-center">
                    <a class="qck-btn w-50 text-white" style="text-decoration: none"
                       :href="pathToEvent">{{$t('choose_another_appointment')}}
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="problem" class="w-100">
              <div v-if="!isMobile">
                <img v-if="event.logo" class="mx-auto d-block" :src="event.logo" height="100px" alt="test">
                <img v-if="event.header" class="mx-auto d-block mb-3" :src="event.header" height="135px"
                     alt="test">
              </div>
              <div v-else>
                <img v-if="event.logo" class="mx-auto d-block" :src="event.logo" height="100px" alt="test">
                <img v-if="event.mobileheader" class="mx-auto d-block" :src="event.mobileheader" height="135px"
                     alt="test">
              </div>
              <div>
                <div :class="isMobile ? '' : 'shadow-lg p-5 mb-5 bg-white rounded'" style="color: #8d8d8d">
                  <div class="text-center mt-3">
                            <span
                                style="font-size: 21px !important; color: #333333; font-family: Poppins">{{$t('error_canceling_appointement')}}<br/>{{$t('try_again_support')}}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Modal -->
            <div v-if="showModal" class="w-100">
              <div v-if="!isMobile">
                <img v-if="event.logo" class="mx-auto d-block" :src="event.logo" height="100px" alt="test">
                <img v-if="event.header" class="mx-auto d-block mb-3" :src="event.header" height="135px"
                     alt="test">
              </div>
              <div v-else>
                <img v-if="event.logo" class="mx-auto d-block" :src="event.logo" height="100px" alt="test">
                <img v-if="event.mobileheader" class="mx-auto d-block" :src="event.mobileheader" height="135px"
                     alt="test">
              </div>
                <div>
                    <div :class="isMobile ? '' : 'shadow-lg p-5 mb-5 bg-white rounded'" style="color: #8d8d8d">
                        <div class="text-center mt-3">
                            <span
                                style="font-size: 21px !important; color: #333333; font-family: Poppins">{{$t('cancel_appointment_question')
                              }}</span>
                        </div>
                        <div class="pt-3 pb-4 text-center">
                          <button class="qck-btn-retour" type="button"
                                  v-on:click="cancelMeetingConfirmed()">{{ $t('Yes') }}
                          </button>
                          <button class="qck-btn ml-2" type="button"
                                  v-on:click="stopCancelMeeting()">{{ $t('No') }}
                          </button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

</template>
<script>
    import axios from 'axios';
    import {api, cognitoCredentials, cognitoApp} from '../../config';
    import {isMobile} from "mobile-device-detect";

    export default {
        data() {
            return {
                event: "",
                pathToEvent: "",
                removed: false,
                loadRemove: false,
                problem: false,
                showModal: true,
                cognitoCredentials: cognitoCredentials,
                cognitoApp: cognitoApp,
                accessToken: ""
            }
        },
        computed: {
          isMobile() {
            return isMobile
          }
        },
        created() {
            this.getCognitoAccessToken();
            this.$i18n.locale = this.$route.params.lang != null ? this.$route.params.lang : "fr";
            axios.get(api.url + 'event/' + this.$route.params.eventId)
              .then(response => {
                if (response.data) {
                  this.event = response.data;
                }
              })
              .catch(error => {
                console.log(error);
                return error;
              });
        },
        methods: {
            stopCancelMeeting() {
                this.showModal = false;
                this.$router.push("/" + this.$route.params.slug);
            },
            cancelMeetingConfirmed() {
                this.showModal = false;
                this.loadRemove = true;
                this.pathToEvent = "/" + this.$route.params.slug
                axios.get(api.url + 'event/remove/' + this.$route.params.itemId + "/" + this.$route.params.eventId, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.accessToken
                    }
                })
                    .then(response => {
                        this.loadRemove = false;
                        this.removed = true;
                        this.problem = false;
                        if (response.data == "again") {
                            this.$router.push(this.pathToEvent)
                        }
                    })
                    .catch(error => {
                        this.removed = false;
                        this.loadRemove = false;
                        this.problem = true;
                        return error;
                    })
            },
            getCognitoAccessToken() {
                axios.post(this.cognitoApp, '',
                    {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'AuthFlow': 'REFRESH_TOKEN_AUTH'
                        },
                        auth: this.cognitoCredentials
                    })
                    .then(response => {
                        this.accessToken = response.data.access_token;
                    })
                    .catch(error => {
                        console.log(error);
                        return error;
                    })
            }
        },
        name: 'Canceled'
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
